import apiFetch from '../apiFetch'
export default function (token, header) {
  return apiFetch({ endPoint: `AuditConfiguration/${header}`, method: 'DELETE', token: token })
}
